import React from 'react';

import noImage from '../../../assets/images/news/no-photo.png';
import { withLocaleContext } from '../../../locales/locale-context.js';
import { prefixPathWithLocale } from '../../../locales/locale-paths.js';
import { FormattedDate, FormattedMessage } from 'react-intl';

import './event-card.scss';

const EventCard = ({ event, localeContext: { locale } }) => {
	return (
		<a
			className="col-xs-12 col-md-12 link"
			href={prefixPathWithLocale(`/events/${event.slug}`, locale)}
		>
			<div className="row event-card">
				<div className="col-xs-12 col-md-4 event-image">
					{event.image && event.image.length !== 0 ? (
						<img
							src={`${process.env.REACT_APP_API_ENDPOINT + event.image.path}`}
							alt={event.title}
						/>
					) : (
						<img src={noImage} alt={event.title} />
					)}
				</div>
				<div className="col-xs-12 col-md-6 event-content">
					<div className="row event-info">
						<div className="col-xs-12 col-md-12 title-col">
							<div className="row title-date">
								<h6 className="col-xs-7 col-md-8 title">{event.title}</h6>
								<div className="col-xs-4 event-date event-date-xs">
									<div className="date-wrapper">
										<FormattedDate value={event.date} day="numeric" />
										<FormattedDate value={event.date} month="short" />
									</div>
								</div>
							</div>
						</div>
						<div
							className="col-xs-12 col-md-12 description"
							dangerouslySetInnerHTML={{ __html: event.description }}
						/>
						<div className="col-xs-12 col-md-3 learn-more">
							<FormattedMessage id="events.learn_more" />
						</div>
					</div>
				</div>
				<div className="col-xs-5 col-md-2 event-date event-date-md">
					<div className="date-wrapper">
						<FormattedDate value={event.date} day="numeric" />
						<FormattedDate value={event.date} month="short" />
					</div>
				</div>
			</div>
		</a>
	);
};
export default withLocaleContext(EventCard);
